<template>
  <div class="hidden" />
</template>

<script>
import preloadImages from "../mixins/preloadImages"
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("config");
const { mapActions } = createNamespacedHelpers("cart");

export default {
  mixins: [preloadImages],
  created: function () {
    let camelizedAttrs =
      Object.fromEntries(Object.entries(this.$attrs).map(e => [this.camelize(e[0]), e[1]]));
    this.initConfig({
      ...camelizedAttrs
    });
    this.loadCart(); // We need cart info for every page on Desktop
  },
  methods: {
    ...mapMutations(["initConfig"]),
    ...mapActions(["loadCart"]),
    camelize: s => s.replace(/-./g, x=>x[1].toUpperCase()),
  },
};
</script>